import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const IntroLoader = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if intro has been shown before in this session
    const hasShownIntro = sessionStorage.getItem('introShown');
    
    if (hasShownIntro) {
      // Skip intro if already shown
      setIsVisible(false);
      onComplete();
      return;
    }

    // Show intro animation
    const timer = setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem('introShown', 'true');
      setTimeout(onComplete, 500); // Wait for fade out
    }, 2500); // 2.5 seconds total

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed inset-0 z-[9999] bg-[#0B0B0C] flex items-center justify-center"
      >
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{
            duration: 0.8,
            ease: [0.6, 0.05, 0.01, 0.9],
          }}
          className="relative"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_brand-architects-7/artifacts/s8bzyq96_IMG_9896.PNG"
            alt="Eternity"
            className="w-[300px] md:w-[400px] h-auto"
          />
          
          {/* Subtle glow */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.3, 0] }}
            transition={{
              duration: 2,
              ease: "easeInOut",
            }}
            className="absolute inset-0 bg-[#EAEAEA] blur-3xl -z-10"
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default IntroLoader;
